'use client'

import { useEffect } from 'react'

import { Loader } from '@/components/primitives/Loader/Loader'

export const StockistWidget = () => {
  const widgetTag = process.env.NEXT_PUBLIC_STOCKIST_WIDGET_TAG

  useEffect(() => {
    // Resolves a bug/limitation with the stockist widget not rendering on client-side navigation
    const initialiseStockistWidget = () => {
      if (typeof window !== 'undefined' && window.__stockist_reload) {
        window.__stockist_reload()
      }
    }

    initialiseStockistWidget()
  }, [])

  return (
    widgetTag && (
      <section data-name="find-a-reseller" className="bg-grey-100 px-4 py-8 lg:px-[120px] lg:py-24">
        <div className="w-full max-w-full content:mx-auto content:max-w-content">
          <div data-stockist-widget-tag={widgetTag}>
            <div className="flex size-full items-center justify-center px-4 py-8 lg:px-[120px] lg:py-24">
              <Loader type="default" />
            </div>
          </div>
        </div>
      </section>
    )
  )
}
